import React from "react";
import { FormSection } from "../../FormBits";
import { DiagnosticEntry, RepairEntry, QualityCheckEntry } from "../ReportTab";

/*
Diagnostic / repair / quality-check reports from GET /ticket/{id}/, rendered
with the Report tab's entry components. Optional: some service centres don't
submit a formal report, so only report types that have entries are shown, and
a ticket with none gets a single neutral line rather than three empty boxes.
*/
const REPORT_TYPES = [
  { key: "diagnostic_report", title: "Diagnostic", Entry: DiagnosticEntry },
  { key: "repair_report", title: "Repair", Entry: RepairEntry },
  { key: "quality_check_report", title: "Quality Check", Entry: QualityCheckEntry },
];

const ReportsSection = function (props) {
  const ticket = props.ticket || {};
  const present = REPORT_TYPES.filter(function (type) {
    return (ticket[type.key] || []).length > 0;
  });

  return (
    <FormSection title="Reports" note="Optional">
      {present.length ? (
        <div className="tn-notes">
          {present.map(function (type) {
            const Entry = type.Entry;
            return (
              <div key={type.key}>
                <div className="tn-note-logs-label tn-report-subhead">{type.title}</div>
                {ticket[type.key].map(function (entry, index) {
                  return <Entry key={entry.id || index} entry={entry} index={index} />;
                })}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="tn-empty">No formal report for this ticket.</div>
      )}
    </FormSection>
  );
};

export default ReportsSection;
